import { useQuery } from 'react-query';

function useBinaryLogoByCustomer(customerId?: string) {
    const { data: logo } = useQuery<{ id: string }>(`customers/${customerId}/logo`, {
        enabled: !!customerId,
    });
    return useQuery<string>(`/customers/${customerId}/logo/${logo?.id}`, {
        enabled: !!logo?.id,
    });
}

export default useBinaryLogoByCustomer;
